// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4082":"7ddb1379","5006":"7ddb1379","6751":"100065f3"}[chunkId] + ".chunk.css";
};